var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "rgba(0, 0, 0, 0.6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5196 8C17.1238 8 16.7518 8.1542 16.4719 8.43421L10.9897 13.9253L9.52856 12.4643C9.24881 12.1845 8.87686 12.0304 8.48122 12.0304C8.08552 12.0304 7.71356 12.1845 7.43375 12.4642C7.15401 12.744 7 13.1159 7 13.5116C7 13.9072 7.15401 14.2792 7.43375 14.5588L9.94257 17.0677C10.2223 17.3475 10.5943 17.5016 10.99 17.5016C11.3855 17.5016 11.7576 17.3474 12.0376 17.0674L18.567 10.5287C19.1444 9.95108 19.1443 9.01136 18.567 8.43375C18.2872 8.15408 17.9152 8 17.5196 8Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.9e865e138361e380649dd299cfcc1dea.svg";
export { ForwardRef as ReactComponent };